import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";

type FlipNoteIconProps = Partial<SVGIconProps>;
const FlipNoteIcon = (props: FlipNoteIconProps) => {
  return (
    <SVGIcon viewBox="0 0 16 16" {...props}>
      <path
        d="M5.33301 1.33398V3.33398"
        stroke="currentCOlor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        d="M10.667 1.33398V3.33398"
        stroke="currentCOlor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        d="M4.66699 8.66602H10.0003"
        stroke="currentCOlor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        d="M4.66699 11.334H8.00033"
        stroke="currentCOlor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
      <path
        d="M10.6667 2.33398C12.8867 2.45398 14 3.30065 14 6.43398V10.554C14 13.3007 13.3333 14.674 10 14.674H6C2.66667 14.674 2 13.3007 2 10.554V6.43398C2 3.30065 3.11333 2.46065 5.33333 2.33398H10.6667Z"
        stroke="currentCOlor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        strokeWidth="1.5"
      />
    </SVGIcon>
  );
};

export default FlipNoteIcon;
